import { applyMiddleware, combineReducers, createStore } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { reducers as rootReducers } from './reducers';
import { createMiddleware } from './middleware';

export * from './actions';

const persistConfig = {
  key: 'narrowband',
  storage,
  whitelist: ['session']
};

const reducers = combineReducers(rootReducers);
const persistedReducer = persistReducer(persistConfig, reducers);

const store = createStore(
  persistedReducer,
  composeWithDevTools(applyMiddleware(thunk, ...createMiddleware()))
);

const persistor = persistStore(store);

export { store, persistor };
